export default {
  id: null,
  obraID: null,
  servicoAnaliseTecID: null,
  observacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/tecserviceanalysisnamodel.js